import { render, staticRenderFns } from "./OrderTransaction.vue?vue&type=template&id=ceca5b60&scoped=true&"
import script from "./OrderTransaction.vue?vue&type=script&lang=js&"
export * from "./OrderTransaction.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransaction.vue?vue&type=style&index=0&id=ceca5b60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceca5b60",
  null
  
)

export default component.exports